import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthPatientService } from '@core/services/auth-patient.service';
import { catchError, of } from 'rxjs';

export const canActivateAuthPatient: CanActivateFn = () => {
  
  const authService = inject(AuthPatientService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    router.navigate(['/sign-in']);
    return false;
  }

  return authService.canActivate().pipe(
    catchError(() => {
      router.navigate(['/sign-in']);
      return of(false);
    })
  );
};
